import { ChevronRight } from '@mui/icons-material'
import { IContinuousRoute } from '$/types'
import NavLinkWithQuery from 'common/components/NavLinkWithQuery'

interface ILineViewBreadcrumb {
  systemViewPath: string
  line?: IContinuousRoute
  continuousRouteId: string
}

const LineViewBreadcrumb = ({
  systemViewPath,
  line,
  continuousRouteId
}: ILineViewBreadcrumb) => {
  return (
    <div className='flex items-center text-sm font-medium'>
      <NavLinkWithQuery to={systemViewPath} className='text-lighthouseBlue'>
        System View
      </NavLinkWithQuery>
      <ChevronRight fontSize='small' className='mx-0.5 text-gray-300' />
      <div>{line?.name ?? `line #${continuousRouteId}`}</div>
    </div>
  )
}

export default LineViewBreadcrumb
